import * as React from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { useToggle } from "react-use";
import { SaveToSnapshotCollectionModal } from "@/modules/snapshots/modals/saveToSnapshotCollection";

interface BusinessReportOutcomeExportProps {
  businessReportOutcome: BusinessReportOutcome;
}

export const BusinessReportOutcomeSaveToCollection: React.FC<BusinessReportOutcomeExportProps> = ({
  businessReportOutcome,
}) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  return (
    <>
      {isOpen && (
        <SaveToSnapshotCollectionModal
          businessReportOutcome={businessReportOutcome}
          isOpen={isOpen}
          setIsOpen={toggleIsOpen}
        />
      )}
      <Button
        onClick={toggleIsOpen}
        variant="default"
        size="sm"
        className="ml-1 rounded bg-primary px-4 py-2 text-white"
      >
        <Save className="mr-2 h-5 w-5" />
        Save to Collection
      </Button>
    </>
  );
};
